import rolesTab from './rolesTab';
import roleTab from './roleTab';
import roleHistoryTab from './roleHistoryTab';

export default [
  roleHistoryTab,
  rolesTab,
  roleTab,
];
